module.exports = __webpack_public_path__ + "fonts/noto-sans-kr-27-900-normal.341c4b4.woff2";